import { render } from "./CardBarChart.vue?vue&type=template&id=4ac00d1a"
import script from "./CardBarChart.vue?vue&type=script&lang=js"
export * from "./CardBarChart.vue?vue&type=script&lang=js"
script.render = render

export default script